import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS, extend } from "@pnp/common";
var Contacts = /** @class */ (function (_super) {
    tslib_1.__extends(Contacts, _super);
    function Contacts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Contacts.prototype.getById = function (id) {
        return new Contact(this, id);
    };
    /**
    * Create a new Contact for the user.
    *
    * @param givenName The contact's given name.
    * @param surName The contact's surname.
    * @param emailAddresses The contact's email addresses.
    * @param businessPhones The contact's business phone numbers.
    * @param additionalProperties A plain object collection of additional properties you want to set on the new contact
    */
    Contacts.prototype.add = function (givenName, surName, emailAddresses, businessPhones, additionalProperties) {
        var _this = this;
        if (additionalProperties === void 0) { additionalProperties = {}; }
        var postBody = extend({
            businessPhones: businessPhones,
            emailAddresses: emailAddresses,
            givenName: givenName,
            surName: surName,
        }, additionalProperties);
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                contact: _this.getById(r.id),
                data: r,
            };
        });
    };
    Contacts = tslib_1.__decorate([
        defaultPath("contacts")
    ], Contacts);
    return Contacts;
}(GraphQueryableCollection));
export { Contacts };
var Contact = /** @class */ (function (_super) {
    tslib_1.__extends(Contact, _super);
    function Contact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes this contact
     */
    Contact.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a contact object
     *
     * @param properties Set of properties of this contact to update
     */
    Contact.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    return Contact;
}(GraphQueryableInstance));
export { Contact };
var ContactFolders = /** @class */ (function (_super) {
    tslib_1.__extends(ContactFolders, _super);
    function ContactFolders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContactFolders.prototype.getById = function (id) {
        return new ContactFolder(this, id);
    };
    /**
     * Create a new Contact Folder for the user.
     *
     * @param displayName The folder's display name.
     * @param parentFolderId The ID of the folder's parent folder.
     */
    ContactFolders.prototype.add = function (displayName, parentFolderId) {
        var _this = this;
        var postBody = {
            displayName: displayName,
            parentFolderId: parentFolderId,
        };
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                contactFolder: _this.getById(r.id),
                data: r,
            };
        });
    };
    ContactFolders = tslib_1.__decorate([
        defaultPath("contactFolders")
    ], ContactFolders);
    return ContactFolders;
}(GraphQueryableCollection));
export { ContactFolders };
var ContactFolder = /** @class */ (function (_super) {
    tslib_1.__extends(ContactFolder, _super);
    function ContactFolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContactFolder.prototype, "contacts", {
        /**
         * Gets the contacts in this contact folder
         */
        get: function () {
            return new Contacts(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactFolder.prototype, "childFolders", {
        /**
        * Gets the contacts in this contact folder
        */
        get: function () {
            return new ContactFolders(this, "childFolders");
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Deletes this contact folder
     */
    ContactFolder.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a contact folder
     *
     * @param properties Set of properties of this contact folder to update
     */
    ContactFolder.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    return ContactFolder;
}(GraphQueryableInstance));
export { ContactFolder };
//# sourceMappingURL=contacts.js.map